import { captureInvitationKey } from './app/invitation/invitation-link';
/// <reference types="@angular/localize" />
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

captureInvitationKey();
bootstrapApplication(App, appConfig).catch((err) => console.error(err));
